export const name = 'name';
export const first_name = 'first_name';
export const last_name = 'last_name';
export const username = 'username';
export const email = 'email';
export const phone_number = 'phone_numer';
export const document_number = 'document_number';
export const obs = 'obs';
export const liters = 'liters';
export const fueling_mileage = 'fueling_mileage';
export const bill_number = 'bill_number';
export const payment_method = 'payment_method';
export const brand = 'brand';
export const consumption_100km = 'consumption_100km';
export const datasheet = 'datasheet';
export const activity = 'activity';
export const origin = 'origin';
export const destination = 'destination';
export const initial_mileage = 'initial_mileage';
export const final_mileage = 'final_mileage';
export const distance_traveled = 'distance_traveled';
export const work_order = 'work_order';
export const service_order = 'service_order';
export const has_external_owner = 'has_external_owner';
export const owner = 'owner';
export const identifier = 'identifier';
export const model = 'model';
export const plate_number = 'plate_number';
export const year = 'year';
